import { createFileRoute } from "@tanstack/react-router";
import { SinceCalculator } from "@/components/tools/SinceCalculator";

export const Route = createFileRoute("/tools/hari-sahabat")({
  head: () => ({
    meta: [
      { title: "Kalkulator Lama Bersahabat - Sudah Berapa Tahun Sahabatan?" },
      { name: "description", content: "Hitung sudah berapa lama kamu bersahabat dengan dia. Hasil tahun, bulan, hari + weton tanggal pertemuan." },
      { property: "og:title", content: "Kalkulator Lama Bersahabat" },
      { property: "og:description", content: "Berapa lama kamu sahabatan dengan dia?" },
    ],
  }),
  component: () => (
    <SinceCalculator
      title="Kalkulator Lama Bersahabat"
      intro="Kamu dan sahabatmu sudah kenal sejak kapan? Hitung berapa lama persahabatan kalian dalam hari, bulan, dan tahun."
      dateLabel="Tanggal pertama kenal"
      verb="bersahabat"
      iconKey="since-friends"
      storageKey="sahabat"
      path="/tools/hari-sahabat"
      body={[
        { heading: "Untuk apa kalkulator ini?", text: "Persahabatan yang panjang layak dirayakan. Kalkulator ini menghitung berapa lama kamu dan sahabatmu sudah saling kenal - dari ratusan hari sampai puluhan tahun." },
        { heading: "Cara pakai", text: "Pilih tanggal kalian pertama kali kenal atau kalian anggap sebagai 'awal sahabatan'. Kami hitung sampai hari ini, lengkap dengan weton tanggal itu." },
        { heading: "Ide untuk dibagikan", text: "Bagikan hasil ke sahabatmu sebagai pengingat. Cocok untuk caption ucapan ulang tahun persahabatan atau reuni kecil-kecilan." },
      ]}
      faq={[
        { q: "Tanggal mana yang harus dipakai?", a: "Bebas - tanggal pertama kenal, hari pertama satu kelas, atau hari pertama saling kontak. Yang penting konsisten." },
        { q: "Apakah perlu sahabatku punya akun?", a: "Tidak. Kamu cukup salin link hasil dan kirim ke dia." },
        { q: "Bisa untuk grup persahabatan?", a: "Bisa - tinggal pakai tanggal awal grup terbentuk." },
        { q: "Bagaimana kalau saya lupa tanggal pasti?", a: "Pilih perkiraan terbaik. Hasilnya tetap memberi gambaran umum." },
        { q: "Apakah ada batas waktu?", a: "Tidak ada. Sejauh kalender Masehi mendukung, kalkulator akan menghitung." },
      ]}
    />
  ),
});